import { render, staticRenderFns } from "./pushMsg.vue?vue&type=template&id=638e6d32&scoped=true&"
import script from "./pushMsg.vue?vue&type=script&lang=js&"
export * from "./pushMsg.vue?vue&type=script&lang=js&"
import style0 from "./pushMsg.vue?vue&type=style&index=0&id=638e6d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e6d32",
  null
  
)

export default component.exports